import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]
  static values = {
    returnTitle: String,
    returnUrl: String
  }

  connect() {
    if (!this.hasReturnUrlValue) {
      this.rememberReturnLocation()
    }

    if (this.element.hasAttribute("open")) {
      this.element.removeAttribute("open")
      requestAnimationFrame(() => this.element.showModal())
    }
  }

  open(event) {
    if (event.target !== this.frameTarget || this.element.open) return

    this.rememberReturnLocation()
    this.element.showModal()
  }

  close(event) {
    event?.preventDefault()

    if (this.element.open) {
      this.element.close()
    } else {
      this.afterClose()
    }
  }

  afterClose() {
    this.reset()
    this.restoreReturnLocation()
  }

  reset() {
    this.frameTarget.innerHTML = ""
    this.frameTarget.removeAttribute("src")
  }

  visitMissingFrame(event) {
    if (event.target !== this.frameTarget) return

    event.preventDefault()
    this.close()
    event.detail.visit(event.detail.response)
  }

  rememberReturnLocation() {
    this.returnUrlValue = window.location.href
    this.returnTitleValue = document.title
  }

  restoreReturnLocation() {
    if (this.hasReturnUrlValue && window.location.href !== this.returnUrlValue) {
      history.replaceState(history.state, "", this.returnUrlValue)
    }

    if (this.hasReturnTitleValue) {
      document.title = this.returnTitleValue
    }
  }
}
